<template>
    <div class="question-root-node">
        <div v-for="(question,index) in questionList" :key="index" style="position: relative;">
            <question-complete :question="question" v-if="question.type === 1"></question-complete>
            <question-single :question="question" v-if="question && question.type === 2"></question-single>
            <question-multiple :question="question" v-if="question.type === 3"></question-multiple>
        </div>
    </div>
</template>

<script>
    import questionSingle from './question-single'
    import questionMultiple from './question-multiple'
    import questionComplete from './question-complete'

    export default {
        props: {
            questionList: {
                required: true,
                type: Array
            },
            type: { required: false },
        },
        name: "question-root-node",
        components: {
            questionSingle,
            questionMultiple,
            questionComplete
        },
        methods: {}
    }
</script>
<style lang="scss" scoped>
    .question-root-node {
        height: 680px;
        overflow: auto;
        padding-bottom: 74px;
        
        .read-only {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.1);
                    z-index: 99;
                    height: 100%;
                }
    }
</style>

